var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-modal',{ref:"popModal",attrs:{"hide-footer":"","size":"xl","title":_vm.menu.title}},[_c('iframe',{staticStyle:{"width":"100%","border":"none","height":"calc(100vh - 150px)"},attrs:{"src":_vm.smartUrl,"border":"0"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }